import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, FileText, Award, PenTool, Atom, ShieldCheck, Download } from "lucide-react";
import PageHeader from "../components/PageHeader";
import useReveal from "../hooks/useReveal";
import { images, navPaths } from "../mock/mock";
import { useLang } from "../i18n/LanguageContext";
import Seo from "../components/Seo";

const regIcons = [Award, ShieldCheck, PenTool];

export default function Innovazione() {
  const { t } = useLang();
  useReveal([t]);
  const n = t.innovation;
  return (
    <main>
      <Seo
        title="Innovazione & Brevetto | Sferificazione molecolare — MichelChef®"
        description="Il brevetto MichelChef®: sferificazione molecolare e rigenerazione dei piatti che preserva aromi e sapori. Innovazione al servizio della tradizione."
        path="/innovazione"
        image={images.molecular}
      />
      <PageHeader crumb={n.crumb} eyebrow={n.eyebrow} title={n.title} subtitle={n.subtitle} image={images.sousVide} homeLabel={t.common.home} />

      <section className="py-24 max-w-7xl mx-auto px-5 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-14 items-center">
          <div className="reveal relative">
            <img src={images.molecular} alt="" className="rounded-3xl w-full h-[460px] object-cover shadow-2xl" />
            <div className="absolute -top-5 -right-5 grid place-items-center w-24 h-24 rounded-2xl bg-[#D8382E] text-white shadow-xl floaty"><Atom size={44} /></div>
          </div>
          <div className="reveal reveal-delay-1">
            <span className="inline-flex items-center gap-2 rounded-full bg-[#17784A]/10 text-[#17784A] px-4 py-1.5 text-sm font-semibold">
              <FileText size={15} /> {n.date}
            </span>
            <h2 className="font-display font-extrabold text-3xl lg:text-4xl mt-4 text-[#14110F]">{n.patentTitle}</h2>
            <p className="mt-6 text-[#3B342E]/90 text-lg leading-relaxed">{n.patentBody}</p>
            <p className="mt-5 text-[#3B342E]/90 text-lg leading-relaxed">
              {n.patentExtraPre}<span className="text-[#17784A] font-semibold">{n.patentExtraHi}</span>{n.patentExtraPost}
            </p>
          </div>
        </div>
      </section>

      <section className="bg-[#F3EFE7] py-24">
        <div className="max-w-7xl mx-auto px-5 lg:px-8">
          <div className="reveal text-center max-w-2xl mx-auto">
            <span className="text-[#D8382E] font-semibold text-sm uppercase tracking-wider">{n.regEyebrow}</span>
            <h2 className="font-display font-extrabold text-3xl lg:text-4xl mt-3 text-[#14110F]">{n.regTitle}</h2>
            <p className="mt-4 text-[#3B342E]/80 text-lg">{n.regSub}</p>
          </div>
          <div className="mt-14 grid md:grid-cols-3 gap-6">
            {n.registrations.map((rg, i) => {
              const Icon = regIcons[i];
              return (
                <div key={i} className={`reveal reveal-delay-${i} group bg-white rounded-2xl p-8 shadow-sm border border-black/5 card-lift hover:shadow-xl`}>
                  <span className="grid place-items-center w-14 h-14 rounded-2xl bg-[#17784A] text-white group-hover:scale-110 transition-transform"><Icon size={26} /></span>
                  <h3 className="font-display font-bold text-xl mt-5 text-[#14110F]">{rg.label}</h3>
                  <p className="mt-2 text-[#3B342E]/75 leading-relaxed">{rg.desc}</p>
                  <span className="mt-5 inline-flex items-center gap-2 text-[#D8382E] font-semibold text-sm cursor-pointer"><Download size={15} /> {t.common.docPdf}</span>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      <section className="py-24 max-w-7xl mx-auto px-5 lg:px-8">
        <div className="reveal rounded-[32px] bg-[#17784A] text-white p-10 lg:p-16 grain relative overflow-hidden">
          <div className="relative max-w-xl">
            <h2 className="font-display font-extrabold text-3xl lg:text-4xl">{n.ctaTitle}</h2>
            <p className="mt-4 text-white/80 text-lg">{n.ctaText}</p>
            <Link to={navPaths.whatWeDo} className="btn-press mt-8 inline-flex items-center gap-2 rounded-full bg-white text-[#14110F] px-7 py-3.5 font-semibold hover:bg-[#FBF9F4]">
              {n.ctaBtn} <ArrowRight size={18} />
            </Link>
          </div>
          <Atom size={260} className="absolute -right-10 -bottom-16 text-white/5 slowspin" />
        </div>
      </section>
    </main>
  );
}
